import axios from 'axios'
import { config, url } from '../../../index'

const state = () => ({
  tableHeaders: [
    {
      title: 'Название',
      isSortable: false
    }
  ],
  positions: [],
  isLoading: true,
  pagination: {
    pageList: {
      active: false,
      pages: []
    },
    currentTake: 10,
    currentPage: 1,
    lastPage: 0
  },
  updateModal: {
    active: false,
    position: {},
    validation: {}
  },
  createModal: {
    active: false,
    newPositionName: '',
    validation: {}
  }
})

const getters = {
  positions: state => state.positions,
  positionListIsLoading: state => state.isLoading,
  positionListTableHeaders: state => state.tableHeaders,
  positionListUpdateModal: state => state.updateModal,
  positionListCreateModal: state => state.createModal
}

const mutations = {
  // получение списка всех должностей
  GET_POSITIONS: (state, positions) => {
    // добавляем к каждому объекту свойство для отрисовки состояния меню (ред./удалить)
    state.positions = positions.map(position => {
      return {
        ...position,
        isControlsActive: false
      }
    })
    // убираем флаг "контент загружается"
    state.isLoading = false
  },
  // вкл/выкл меню (редактировать/удалить)
  POSITION_LIST_TOGGLE_CONTROLS: (state, itemId) => {
    state.positions.forEach((elem) => {
      if (itemId === elem.id) {
        elem.isControlsActive = !elem.isControlsActive
      } else if (itemId !== elem.id) {
        elem.isControlsActive = false
      }
    })
  },
  // выкл меню (редактировать/удалить) при клике вне элемента
  CLOSE_POSITION_LIST_CONTROLS: (state) => {
    state.positions.forEach((elem) => {
      elem.isControlsActive = false
    })
  },
  // показ модалки для редактирования записи
  SHOW_POSITION_LIST_UPDATE_MODAL: (state, positionId) => {
    state.updateModal.active = true
    // помещаем в модалку копию объекта чтобы редактирование не затрагивало таблицу
    const copies = state.positions.map(position => ({ ...position }))
    state.updateModal.position = copies.filter(position => {
      return position.id === positionId
    }).shift()
  },
  SET_UPDATED_POSITION_NAME: (state, name) => {
    state.updateModal.position.name = name
  },
  SHOW_POSITION_LIST_CREATE_MODAL: (state) => {
    state.createModal.active = true
  },
  SET_CREATED_POSITION_NAME: (state, name) => {
    state.createModal.newPositionName = name
  },
  // закрытие всех модалок
  CLOSE_POSITION_LIST_MODALS: (state) => {
    // модалка редактирвоания
    state.updateModal.active = false
    state.updateModal.position = {}
    // модалка создания
    state.createModal.active = false
    state.createModal.newPositionName = ''
  },
  SET_POSITION_LIST_MODAL_VALIDATION: (state, validationData) => {
    switch (validationData.modal) {
      case 'create':
        state.createModal.validation = validationData.validation
        break
      case 'update':
        state.updateModal.validation = validationData.validation
        break
      default:
        state.createModal.validation = {}
        state.updateModal.validation = {}
    }
  },
  // записть в стейт состояния пагинации
  SET_POSITION_LIST_PAGINATION: (state, paginationData) => {
    state.pagination.currentPage = paginationData.current_page
    state.pagination.lastPage = paginationData.last_page
    // заполняем массив номерами страниц от 1 до последней страницы
    state.pagination.pageList.pages = [...Array(paginationData.last_page).keys()].map(i => ++i)
  },
  TOGGLE_POSITION_LIST_PAGE_LIST: (state) => {
    state.pagination.pageList.active = !state.pagination.pageList.active
  },
  CLOSE_POSITION_LIST_PAGE_LIST: (state) => {
    state.pagination.pageList.active = false
  }
}

const actions = {
  getPositions ({ state, commit }) {
    axios.get(`${url}/positions?per-page=1`, config).then(response => {
      axios.get(`${url}/positions?sort=-id&per-page=${response.headers['x-pagination-total-count']}`, config).then(response => {
        commit('GET_POSITIONS', response.data.data)
      })
    }).catch(error => {
      console.log('ошибка получения списка должностей', error.response ? error.response : error)
    })
  },
  /* getPositionListPrevPage ({ state, commit }) {
    axios.get(`${url}/positions?orderBy=id&orderDir=DESC&take=${currentTake}&page=${currentPage - 1}`, config).then(response => {
      commit('GET_POSITIONS', response.data.data)
      commit('SET_POSITION_LIST_PAGINATION', response.data)
      commit('CLOSE_POSITION_LIST_PAGE_LIST')
    })
  },
  getPositionListNextPage ({ state, commit }) {
    const currentTake = state.pagination.currentTake
    const currentPage = state.pagination.currentPage
    axios.get(`${url}/positions?orderBy=id&orderDir=DESC&take=${currentTake}&page=${currentPage + 1}`, config).then(response => {
      commit('GET_POSITIONS', response.data.data)
      commit('SET_POSITION_LIST_PAGINATION', response.data)
      commit('CLOSE_POSITION_LIST_PAGE_LIST')
    })
  },
  getPositionListPage ({ state, commit }, pageNum) {
    const currentTake = state.pagination.currentTake
    axios.get(`${url}/positions?orderBy=id&orderDir=DESC&take=${currentTake}&page=${pageNum}`, config).then(response => {
      commit('GET_POSITIONS', response.data.data)
      commit('SET_POSITION_LIST_PAGINATION', response.data)
    })
  },
  togglePositionListPageList ({ commit }) {
    commit('TOGGLE_POSITION_LIST_PAGE_LIST')
  }, */
  // переключение всплывающих меню (ред./удалить)
  togglePositionListItemControls ({ commit }, itemId) {
    commit('POSITION_LIST_TOGGLE_CONTROLS', itemId)
  },
  // показ модалки редактирования записи
  showPositionListUpdateModal ({ commit }, positionId) {
    commit('SHOW_POSITION_LIST_UPDATE_MODAL', positionId)
  },
  // редактирование имени записи
  setUpdatedPositionName ({ commit }, name) {
    commit('SET_UPDATED_POSITION_NAME', name)
  },
  // показ модалки создания записи
  showPositionListCreateModal ({ commit }) {
    commit('SHOW_POSITION_LIST_CREATE_MODAL')
  },
  // редактирование имени новой записи
  setCreatedPositionName ({ commit }, name) {
    commit('SET_CREATED_POSITION_NAME', name)
  },
  // закрытие всех модалок
  closePositionListModals ({ commit }) {
    commit('CLOSE_POSITION_LIST_MODALS')
    // закрываем все всплывашки (ред./удалить)
    commit('CLOSE_POSITION_LIST_CONTROLS')
  },
  // создание записи
  createPosition ({ commit, state }) {
    if (state.createModal.newPositionName) {
      const postData = {
        name: state.createModal.newPositionName
      }

      axios.post(`${url}/positions`, postData, config).then(response => {
        this.dispatch('getPositions')
        this.dispatch('closePositionListModals')
      }).catch(error => {
        console.log('Ошибка создания должности:' + error)
      })
    } else {
      commit('SET_POSITION_LIST_MODAL_VALIDATION', { modal: 'create', validation: { type: 'error', message: 'Поле должно быть заполнено' } })
    }
  },
  // редактирование записи
  updatePosition ({ commit, state }) {
    if (state.updateModal.position.name) {
      const positionData = {
        id: state.updateModal.position.id,
        name: state.updateModal.position.name
      }

      axios.put(`${url}/positions/${positionData.id}`, positionData, config).then(response => {
        this.dispatch('getPositions')
        this.dispatch('closePositionListModals')
      }).catch(error => {
        console.log('Ошибка редактирования должности:' + error)
      })
    } else {
      commit('SET_POSITION_LIST_MODAL_VALIDATION', { modal: 'update', validation: { type: 'error', message: 'Поле должно быть заполнено' } })
    }
  },
  // очищаем поля валидации
  clearPositionListModalValidation ({ commit }) {
    commit('SET_POSITION_LIST_MODAL_VALIDATION', { modal: null, validation: null })
  },
  // удаление записи
  deletePosition ({ commit }, positionId) {
    axios.delete(`${url}/positions/${positionId}`, config).then(response => {
      console.log('Должность успешно удалена')
      this.dispatch('getPositions')
      this.dispatch('closePositionListModals')
    }).catch(error => {
      console.log('Ошибка удаления должности:' + error)
    })
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
